import React from 'react'
import './Skills.css'

const Skills = () => {
  return (
   <div className="skills container-fluid" id='skill'>
   <div className="title">
            <h1 className='title_head skill_title'>TECHNOLOGIES</h1>
            <p className='title_para skill_para'>Professional Skills</p>
            </div>
    <div className="container-fluid skill_contain">
        <div className="row skills_wrapper">
        <div class="col-lg-6  ">
          <div class="single-progress">
            <h6 class="text-start">HTML</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">80%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">CSS</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "60%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">60%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">bootstrap</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "60%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">60%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">JAVASCRIPT</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "40%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">40%</span>
          </div>
          </div>
          <div className="col-lg-6">
          <div class="single-progress-adobe  single-progress">
            <h6 class="text-start">ADOBE PHOTOSHOP</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "70%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">70%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">FIGMA</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "70%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">70%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">REACT</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "40%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">40%</span>
          </div>
          <div class="single-progress mt-5">
            <h6 class="text-start">MATERIAL UI</h6>
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{width: "40%"}} aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <span class="label">40%</span>
          </div>
          </div>
          
        
        </div>
    </div>

   </div>
  )
}

export default Skills